/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { checkIfValueIsValid, DescriptionElement } from '../common';

export const getEnrollmentsData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.ENROLLMENTS;

  const enrollmentsData = dataSet[factKey];

  enrollmentsData.areaSource = dataSet?.baseInfo?.areaSource;
  enrollmentsData.areaSourceComment = dataSet?.baseInfo?.areaSourceComment;

  const EnrollmentsFactsRow = ({ facts }) => {
    const descriptionFields = ['preferentialAndCommunity'];

    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      if (descriptionFields.includes(factFieldName)) {
        return (
          <>
            <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
              <div className='object-listing-accordian-list-left'>
                {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
                  objectText?.[factKey]?.[factFieldName]?.label ||
                  facts?.factFieldName}
              </div>
              <div className='object-listing-accordian-list-right'></div>
              <div className='enrollments-desc'>
                <DescriptionElement
                  descriptionText={facts?.value}
                  paragraphClass='enrollment-paragraph'
                />
              </div>
            </div>
          </>
        );
      } else {
        return (
          <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
            <div className='object-listing-accordian-list-left'>
              {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
                objectText?.[factKey]?.[factFieldName]?.label ||
                facts?.factFieldName}
            </div>
            <div className='object-listing-accordian-list-right'>
              {facts?.value}
            </div>
          </div>
        );
      }
    }

    return <></>;
  };

  let fields = [];

  Object.keys(enrollmentsData).forEach((fieldKey, index) => {
    if (checkIfValueIsValid(enrollmentsData[fieldKey])) {
      fields.push(
        <EnrollmentsFactsRow
          key={index}
          facts={{
            factFieldName: fieldKey,
            value: enrollmentsData[fieldKey]
          }}
        />
      );
    }
  });

  const EnrollmentsSection = () => {
    return <div className='enrollments-data-body'>{fields}</div>;
  };

  return {
    component: <EnrollmentsSection />,
    factsCount: fields.length
  };
};
